<script>
import store from '../store';
export default {
    methods: {
        format(_price, decimals = 0) {
            if (!_price) {
                return '**';
            }
            let price = _price / 10000 + '';
            if (decimals > 0) {
                const arr = price.split('.');
                const length = arr[1] ? arr[1].length : 0;
                let complement = decimals - length;
                while (complement) {
                    if (complement < 0) {
                        arr[1] = arr[1].replace(arr[1].charAt(arr[1].length - 1), '');
                        complement++;
                        continue;
                    } else {
                        if (!arr[1]) {
                            arr[1] = '0';
                        } else {
                            arr[1] += '0';
                        }
                    }
                    complement--;
                }
                price = arr.join('.');
            }
            return price;
        },
        formatLower(_price) {
            if (_price < 10000) {
                return this.format(_price, 2);
            } else {
                return this.format(_price, 2);
            }
        },
        hidden(_price) {
            let arr = _price.split('.');
            if (arr[0].length > 1) {
                arr[0] = arr[0].substring(0, arr[0].length-1) + '*';
                // arr[0] = arr[0].replace(arr[0].charAt(arr[0].length - 1), '*');
            } else {
                arr[1] = arr[1].replace(arr[1].charAt(0), '*');
            }
            return arr.join('.');
        }
    },
    computed: {
        price() {
            // 有限展示上月成交价, 如果没有展示厂商指导价
            return store.price.lower.lastMonthDealPriceFormat || this.hidden(this.format(store.price.normal.price, 2)) + '万元';
        },
        lowerPrice() {
            return store.price.normal.priceOff;
        }
    }
}
</script>

<template>
    <div class="price">
        <h3 class="current">{{price}}</h3>
        <div class="lower" v-if="lowerPrice">
            <p>最高降价</p>
            <img src="../../assets/arrow-price.png" alt="">
            <p>{{formatLower(lowerPrice)}}万元</p>
        </div>
    </div>
</template>

<style lang="stylus" scoped>
.price
    display flex 
    flex-direction row
    align-items flex-end
    padding 0.5rem 0;
    font-weight bold
    .current 
        line-height 1.1
        font-size 0.95rem
        white-space nowrap
        color #ff6600
    .lower
        display flex
        flex-direction row
        align-items center
        margin-left 0.426rem
        white-space nowrap
        color #417505
    .lower img
        margin 0 0.1rem
        height 0.64rem
    .lower p
        font-size 0.64rem 
</style>